import { MarketingWorkFile } from "@/bryntum-lib/models/MarketingWorkFile";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Globe, Loader2 } from "lucide-react";
import { TEST_DRIVE_SITE_PAGE_UNAVAILABLE_MSG } from "@/react/components/entityViews/marketingPages/utils";

interface PublishMarketingPageActionProps {
  file: MarketingWorkFile;
  generating: boolean;
  onPublish: () => void;
  /** When true, page generation is blocked on Swivu Test Drive boards. */
  testDriveRestricted?: boolean;
}

export function PublishMarketingPageAction({
  file,
  generating,
  onPublish,
  testDriveRestricted = false,
}: PublishMarketingPageActionProps) {
  const disabled = file.archived || generating || testDriveRestricted;
  const title = testDriveRestricted
    ? TEST_DRIVE_SITE_PAGE_UNAVAILABLE_MSG
    : file.archived
      ? "Unarchive this work file to publish."
      : "Publish a hosted marketing page from this work file";

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      className="h-8 min-h-8 shrink-0 gap-1 px-3 text-xs"
      disabled={disabled}
      onClick={onPublish}
      title={title}
    >
      {generating ? (
        <Loader2 className="size-3.5 animate-spin" aria-hidden />
      ) : (
        <Globe className="size-3.5" aria-hidden />
      )}
      {generating ? "Publishing…" : "Publish page"}
    </Button>
  );
}
